var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDateBg = function SvgDateBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "61px",
    viewBox: "0 0 90 61",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "date_bg")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16_TeamAbout",
    transform: "translate(-820.000000, -2849.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "date_bg",
    transform: "translate(820.000000, 2849.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    cx: 30,
    cy: 30.5,
    r: 30
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-12",
    cx: 60,
    cy: 30.5,
    r: 30
  }))))));
};
export default SvgDateBg;